// Nederlandse naam per collectie, voor de melding onder de statuskaarten.
const LABELS = {
    Tasks: 'taken',
    Users: 'teamleden',
    EventResults: 'activiteiten',
    QuestionnairesResponses: 'onderzoeksresponsen',
    PersonaPresenceReports: 'aanwezigheid',
}

/**
 * Zin die vertelt welke gegevens ontbreken in een gezondheidsbeeld.
 *
 * Een geweigerde read levert een lege lijst op, geen fout: zonder deze melding
 * ziet een onvolledig beeld eruit als een laag scorend project.
 * AI-CONTEXT: See docs/inbox.md Bug #133
 *
 * @param {Array<string>|null|undefined} collections - Collecties die niet gelezen konden worden
 * @returns {string|null} De melding, of null wanneer er niets ontbreekt
 */
const describeUnavailableData = (collections) => {
    const list = Array.isArray(collections) ? collections.filter(Boolean) : []

    if (list.length === 0) return null

    const labels = list.map((name) => LABELS[name] || name)
    const spelled = labels.length === 1
        ? labels[0]
        : `${labels.slice(0, -1).join(', ')} en ${labels[labels.length - 1]}`

    return `${spelled.charAt(0).toUpperCase()}${spelled.slice(1)} konden niet gelezen worden, dus dit beeld is onvolledig.`
}

export default describeUnavailableData
